export default __webpack_public_path__ + "static/media/popupcard.53f05586.png";